import React, { useMemo } from "react";

import { Brand } from "../../configurations";
import { PageContextUtils } from "../../utils";
import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";

const TestComponentLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "debug/component" */

      "./TestComponent"
    ),
  loading: EmptyComponent
});

export const TestComponent = () => {
  const brandId = useSelector(UserContextSelectors.brandId);

  const loaded = useMemo(() => {
    const { environment } = PageContextUtils.getEnvironmentData();
    return brandId === Brand.Sport_NL && environment !== "production";
  }, [brandId]);

  if (!loaded) return null;

  return <TestComponentLoadable />;
};
